import { isMockMode, post, simulateDelay } from "../api";

/**
 * Request parameters:
 *  OfferingId (Guid)
 * 	Avatar_Base64 (string)
 */
export const updateOfferingAvatar = (data) => {
	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(50, () => testData);
	}

	return post(`Offerings/UpdateAvatar`, data);
};
